<template>
    <div class="o-crops">
        <div class="l-row m-card">
            <div class="l-row__column m-card__column">
                <div class="l-row m-card__container">
                    <m-control
                        :background-gray="true"
                        type="searchText"
                        label="Substancja"
                        placeholder="Znajdź..."
                        name="active-substances"
                        model-name="active-substances"
                        @input="build('name', $event)"
                        :value="query['name']"
                    />
                </div>
            </div>
        </div>
        <o-list
            vuex-action-fetch="fetchActiveSubstances"
            vuex-action-fetch-next-page="fetchActiveSubstancesNextPage"
            vuex-getter-model="activeSubstances"
            vuex-getter-status="activeSubstancesStatus"
            router-single-name="active-substance"
        >
            <template slot="list" slot-scope="props">
                <p class="m-list__itemTitle m-list__itemTitle--margins m-list__itemTitle--capitalize">
                    {{ props.list.item.name }}
                </p>
            </template>
        </o-list>
    </div>
</template>

<script>
export default {
    metaInfo: {
        title: 'Substancje aktywne'
    },
    computed: {
        query() {
            return this.$store.getters.activeSubstancesQuery
        }
    },
    methods: {
        build(name, value) {
            this.$store.dispatch('setActiveSubstancesSearchQuery', {
                name,
                value
            }).then(() => {
                this.$store.dispatch('fetchActiveSubstances').catch(() => {})
            })
        }
    }
}
</script>
